import {Spin} from 'antd';
import {FlightEditorConfiguration} from 'components/flighteditor/unified/configuration';
import React from 'react';

export const schedulingFlightEditorConfiguration: FlightEditorConfiguration = {
    editPermission: {
        anyOf: ['flytsuite.schedule.flight'],
        unauthorized: 'readOnly'
    },
    features: {
        schedulingSteps: {enabled: true},
        weatherDelay: {enabled: false},
        notesForPilot: {enabled: true},
        delete: {
            enabled: true,
            permission: {anyOf: ['flytsuite.schedule.flight'], unauthorized: 'disable'}
        },
        printout: {enabled: true},
        notify: {
            enabled: true,
            permission: {
                anyOf: ['flytsuite.schedule.passenger', 'flytsuite.schedule.flight'],
                unauthorized: 'hide'
            }
        },
        makeExpected: {
            enabled: true,
            permission: {anyOf: ['flytsuite.schedule.flight'], unauthorized: 'disable'}
        },
        lock: {enabled: false},
        bless: {enabled: false}
    },
    routes: (flight, loading) => [
        {
            path: '/app/scheduling/flight',
            title: 'Scheduled Flights',
            breadcrumbName: 'Scheduled Flights'
        },
        {
            path: null,
            breadcrumbName: loading ? <Spin /> : flight?.desig
        }
    ]
};

export default schedulingFlightEditorConfiguration;
